import * as React from "react";
import PropTypes from "prop-types";
import Section from "nx-components/Section";
import ErrorHandler from "nexia_mobile/components/ErrorHandler";

const DetailsSection = ({ children, style, ...otherProps }) => (
  <div style={{ marginTop: "2vh" }}>
    <Section
      style={{
        borderTop: otherProps.label ? "1px solid #E3E3E3" : "",
        ...style,
      }}
      {...otherProps}
    >
      <ErrorHandler>
        <div
          data-component-name="DetailsSection"
          data-component-prop-label={otherProps.label}
        >
          {children}
        </div>
      </ErrorHandler>
    </Section>
  </div>
);
DetailsSection.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  ...Section.propTypes,
};

export default DetailsSection;



// WEBPACK FOOTER //
// ./src/components/Details/DetailsSection.jsx